<template>
  <my-dialog ref="selectSupply" title="选择供应商" dialogType="form" :visible.sync="showDialog" :close-on-click-modal="false"
    @close="closeDialog" width="80%" append-to-body>
    <div>
      <el-form :inline="true" :model="formInline" class="user-search" style="margin-top: -10px">
        <el-form-item label="供应商名称：">
          <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.name"
            placeholder="请输入供应商名称"></el-input>
        </el-form-item>
        <el-form-item label="电话：">
          <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.contactPhone"
            placeholder="请输入电话"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">
            搜索
          </el-button>
          <el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
        </el-form-item>
      </el-form>
      <STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading" border stripe highlight
        @current-change="handleSupplyCurrentChange">
      </STable>
      <!-- 分页组件 -->
      <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">取消</el-button>
      <el-button size="small" type="primary" class="title" @click="submitSelectSupply">
        确认
      </el-button>
    </div>
  </my-dialog>
</template>

<script>
import {
  getSupplyInfoPageList,
} from "@/api/baseDataApi.js";
export default {
  data() {
    return {
      showDialog: false,
      pageShow: true,
      loading: false, // 显示加载
      listData: [],
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      formInline: {
        pageIndex: 1,
        pageSize: 10,
        name: "",
        contactUser: "",
        contactPhone: "",
      },
      columnsData: [], //显示列
      listColumns: [
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          fixed: "left",
          width: "80",
          isKeep: true,
        },
        {
          prop: "name",
          label: "供应商名称",
          isKeep: true,
          minWidth: "120",
        },
        {
          prop: "contactUser",
          label: "联系人",
          minWidth: "100",
        },
        {
          prop: "contactPhone",
          label: "联系电话",
          minWidth: "120",
        },
        {
          prop: "address",
          label: "地址",
        },
        {
          prop: "creator",
          label: "创建人",
          minWidth: "120",
        },
        {
          prop: "createTime",
          label: "创建时间",
          minWidth: "120",
        },
        {
          prop: "editor",
          label: "维护人",
          minWidth: "120",
        },
        {
          prop: "updateTime",
          label: "维护时间",
          minWidth: "120",
        },
      ],
    };
  },
  // 注册组件
  components: {},
  created() {
    // 初始列
    this.getCheckBox(this.listColumns.map((item) => item.label));
  },
  computed: {},
  methods: {
    //展示弹窗
    showSelectCustomerDialog() {
      this.showDialog = true;
      this.search();
    },
    // 获取筛选框
    getCheckBox(val) {
      let arr = this.listColumns.filter((v) => !val.includes(v.label));
      this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
    },
    // 表格选中事件
    handleSupplyCurrentChange(currentRow) {
      if (currentRow == null || currentRow == undefined || currentRow == "") {
        return;
      }
      let keyId = currentRow.keyId;
      this.selectionKeyId = keyId;
    },
    changePages() { },
    // 获取列表
    getListData() {
      this.loading = true;
      getSupplyInfoPageList(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 重置
    clearAll() {
      this.$data.formInline = this.$options.data.call(this).formInline;
      this.search();
    },
    inputChange(val) {
      this.search();
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.formInline.pageIndex = 1;
      this.pageShow = false;
      this.$nextTick(() => {
        this.pageShow = true;
      });
      this.getListData();
    },
    //选中后提交
    submitSelectSupply() {
      if (this.selectionKeyId == "") {
        this.$message.error("请选择供应商");
        return;
      }
      this.$parent.chooseSupply(this.selectionKeyId);
      this.closeDialog();
    },
    // 关闭
    closeDialog() {
      this.showDialog = false;
      this.selectionKeyId = "";
      this.$data.formInline = this.$options.data.call(this).formInline;
      this.listData = [];
      this.selection = [];
    },
  },
};
</script>

<style scoped>
.one_1 {
  padding: 2px 20px;
  background: #e6f7ff;
  border: 1px solid #6acaf3;
  color: #56bbfd;
  border-radius: 2px;
}

.one_2 {
  padding: 2px 20px;
  background: #fcd4ff;
  border: 1px solid #dfbce2;
  color: #ea7cff;
  border-radius: 2px;
}
</style>